/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
interface IIgnorePlayerEventsProps {
  children?: React.ReactNode;
}

const ignoreEvents = (e) => e.stopPropagation();

const IgnorePlayerEvents = ({ children }: IIgnorePlayerEventsProps) => {
  return (
    <div onTouchStart={ignoreEvents} onDoubleClick={ignoreEvents} onClick={ignoreEvents}>
      {children}
    </div>
  );
};

export default IgnorePlayerEvents;
